import React, { useState, useEffect } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../utils/PiePage.component'
import InputField from '../../utils/InputMUI'
import SelectField from '../../utils/SelectMUI'
import MultiSelect from '../../utils/MultiSelectMUI'
import { saveUpdateCommunityPersonalApi, getAllCommunityForParentCommunity, getCommunityPersonalApi, getStateListForDealer,getDistrcitStateListForDealer } from './DealerActioncreator'
import moment from 'moment'


const tieUpFeePaidByData = [
    { code: "CHECK", name: "check" },
    { code: "ONLINE", name: "Online" },
]
const AgreementFeeData = [
    { code: "No Amt Paid", name: "NO Amount Paid" },
    { code: "Amt Paid Non Refund", name: "Amount Paid Non Refund" },
    { code: "Amt Paid Refundable", name: "Amount Paid Refundable" },
]
const VendorTypeData = [
    { code: "DEALER", name: "Dealer" },
    { code: "SUB DEALER", name: "Sub Dealer" },
    // { code: "RETAIL STORE OWN", name: "Retail Store Own" },
    // { code: "OEM STORE", name: "OEM Store" },

    // { code: "GARAGE", name: "Garage" },
    // { code: "CONSULTANT", name: "Consultant" },
    // { code: "DSA", name: "DSA" },
    // { code: "WAREHOUSE", name: "Warehouse" },
    // { code: "FI AGENCY", name: "FI Agency" },
    // { code: "LOGISTICS", name: "Logistics" },
    // { code: "WEBSITE", name: "Website" },
    // { code: "BODY MANUFACTURER", name: "Body Manufacturer" },
    // { code: "REFERRAL", name: "Referral" },
    // { code: "TELE CALLING", name: "Tele Calling" },
    // { code: "OTHERS", name: "Others" },
    // { code: "MONEY LENDER", name: "Money Lender" },
    // { code: "VALUATOR", name: "Valuator" },
    // { code: "AGENT", name: "Agent" },
    // { code: "DST", name: "DST" },
    // { code: "EXTERNAL DST", name: "External DST" },
    // { code: "LAWYER", name: "Lawyer" },
    // { code: "TECHNICAL AGENT", name: "Technical Agent" },
    // { code: "LEGAL AGENT", name: "Legal Agent" },
    // { code: "AUCTIONEER", name: "Auctioneer" },
    // { code: "DIRECT BUSINESS", name: "Direct Business" }
];


const branchesData = [
    { code: "mp", name: "Madhya Pradesh" },
    { code: "chhattisgarh", name: "Chhattisgarh" },


    { code: "delhi", name: "Delhi" },
    { code: "up", name: "Uttar Pradesh" },
    { code: "uttarakhand", name: "Uttarakhand" },
    { code: "haryana", name: "Haryana" },
    { code: "punjab", name: "Punjab" },
    { code: "hp", name: "Himachal Pradesh" },
    { code: "jammu-kashmir", name: "Jammu & Kashmir" },
    { code: "ladakh", name: "Ladakh" },
    { code: "rajasthan", name: "Rajasthan" },
    { code: "bihar", name: "Bihar" },
    { code: "jharkhand", name: "Jharkhand" }
];
const vendorBranchesData = [
    {
        code: "gurugram",
        name: "Gurugram"
    },
];
const gradeData = [
    {
        code: "A",
        name: "A"
    },
    {
        code: "B",
        name: "B"
    },
    {
        code: "C",
        name: "C"
    },
    {
        code: "D",
        name: "D"
    },
];
const isActiveData = [
    {
        code: true,
        name: "Active"
    },
    {
        code: false,
        name: "Inactive"
    }
]



export default function BasicDetails({ handlePage, handleTabs, commId, Detaildata }) {
    const [responseMsg, setresponseMsg] = useState("")
    const [errors, setErrors] = useState({})
    const [loaderState, setloaderState] = useState(false)
    const [parentVendorData, setParentVendorData] = useState([])
    const [stateData, setStateData] = useState([])
    const [DistrictstateData, setDistrictstateData] = useState([])
    const [ObjectData, setObjectData] = useState({
        name: '',
        mobileNumber: '',
        email: '',
        alternativeEmailId: '',
        multipleEmail: '',
        communityType: '',
        grade: '',
        parentCommunityId: '',
        active: '',
        branches: [],
        vendorBranches: "",
        pointOfContact: '',
        venderOwnerName: '',
        panNumber: '',
        venderAadhaarNumber: '',
        firmGstNumber: '',
        tieUpAmount: '',
        tieUpFeePaidBy: '',
        tieUpFeeDate: moment(new Date()).format("YYYY-MM-DD"),
        tieUpFeeBank: '',
        tieUpFeeRefId: '',
        agreementFeeType: '',
        additionalInfo: '',
    })


    useEffect(() => {
        getAllCommunityForParentCommunity((callback) => {

            if (callback && callback?.message == "success" && callback?.status == 200) {
                setParentVendorData(callback?.data)
            } else {
                setParentVendorData([])
            }
        })
    }, [])

    const validateForm = () => {
        let newErrors = {};

        if (!ObjectData.name?.trim()) newErrors.name = "Vendor name is required";
        // if (!ObjectData.mobileNumber?.trim()) {
        //     newErrors.mobileNumber = "Contact number is required";
        // } else if (!/^[0-9]{10}$/.test(ObjectData.mobileNumber)) {
        //     newErrors.mobileNumber = "Contact number must be 10 digits";
        // }
        if (!ObjectData.email?.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(ObjectData.email)) {
            newErrors.email = "Enter a valid email address";
        }
        if (!ObjectData.communityType) newErrors.communityType = "Vendor type is required";
        if (ObjectData.active === '') newErrors.active = "Active status is required";
        if (!ObjectData.branches?.length) newErrors.branches = "At least one branch is required";
        if (!ObjectData.vendorBranches) newErrors.vendorBranches = "Vendor branch is required";
        if (!ObjectData.pointOfContact?.trim()) newErrors.pointOfContact = "Point of Contact is required";
        if (!ObjectData.venderOwnerName?.trim()) newErrors.venderOwnerName = "Vendor Owner Name is required";
        // if (!ObjectData.panNumber?.trim()) newErrors.panNumber = "PAN number is required";
        if (!ObjectData.venderAadhaarNumber?.trim()) newErrors.venderAadhaarNumber = "Aadhaar number is required";
        if (!ObjectData.firmGstNumber?.trim() && ObjectData.communityType !== "SUB DEALER") newErrors.firmGstNumber = "GSTIN is required";

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        if (Detaildata?.rowData?.communityId) {
            setloaderState(true)
            getCommunityPersonalApi(Detaildata?.rowData?.communityId, (callback) => {
                console.log("Detaildata?.communityId", callback)
                console.log("VendorTypeData?.filter((el)=> el.name === callback?.data?.communityType)", VendorTypeData?.filter((el) => el.name === callback?.data?.communityType).map(el => el.code))
                if (callback && callback?.status == 200 && callback?.message == "success") {
                    setObjectData({
                        name: callback?.data?.name || '',
                        mobileNumber: callback?.data?.mobileNumber || '',
                        email: callback?.data?.email || '',
                        alternativeEmailId: callback?.data?.alternativeEmailId || '',
                        multipleEmail: callback?.data?.multipleEmail || '',
                        communityType: (VendorTypeData?.filter((el) => el.name === callback?.data?.communityType).map(el => el.code))[0] || '',
                        grade: callback?.data?.grade || '',
                        parentCommunityId: callback?.data?.parentCommunityId || '',
                        active: callback?.data?.active || '',
                        branches: callback?.data?.branches || [],
                        vendorBranches: callback?.data?.vendorBranches || "",
                        pointOfContact: callback?.data?.pointOfContact || '',
                        venderOwnerName: callback?.data?.venderOwnerName || '',
                        panNumber: callback?.data?.panNumber || '',
                        venderAadhaarNumber: callback?.data?.venderAadhaarNumber || '',
                        firmGstNumber: callback?.data?.firmGstNumber || '',
                        tieUpAmount: callback?.data?.tieUpAmount || '',
                        tieUpFeePaidBy: callback?.data?.tieUpFeePaidBy || '',
                        tieUpFeeDate: callback?.data?.tieUpFeeDate || '',
                        tieUpFeeBank: callback?.data?.tieUpFeeBank || '',
                        tieUpFeeRefId: callback?.data?.tieUpFeeRefId || '',
                        agreementFeeType: callback?.data?.agreementFeeType || '',
                        additionalInfo: callback?.data?.additionalInfo || '',
                    })
                } else {
                    setObjectData({
                        name: '',
                        mobileNumber: '',
                        email: '',
                        alternativeEmailId: '',
                        multipleEmail: '',
                        communityType: '',
                        grade: '',
                        parentCommunityId: '',
                        active: '',
                        branches: [],
                        vendorBranches: "",
                        pointOfContact: '',
                        venderOwnerName: '',
                        panNumber: '',
                        venderAadhaarNumber: '',
                        firmGstNumber: '',
                        tieUpAmount: '',
                        tieUpFeePaidBy: '',
                        tieUpFeeDate: '',
                        tieUpFeeBank: '',
                        tieUpFeeRefId: '',
                        agreementFeeType: '',
                        additionalInfo: '',
                    })
                }
                setloaderState(false)
            })
        }
    }, [Detaildata?.rowData])


    const inputChange = (e, type) => {

        let changeObjectData = Object.assign({}, ObjectData)

        if (type === 'mobileNumber' || type === 'email' || type === "alternativeEmailId") {

            if (type === 'mobileNumber') {
                if (e.length <= 10) {
                    changeObjectData[type] = e

                } else {
                    e = e.slice(0, 10)
                    // console.log(typeof (e))

                    changeObjectData[type] = e

                }
            }

            if (type === 'email' || type === "alternativeEmailId") {
                if (type === 'email' || type === "alternativeEmailId") {
                    if (e.length <= 100) {
                        changeObjectData[type] = e

                    } else {
                        e = e.slice(0, 100)

                        changeObjectData[type] = e

                    }
                }
            }

        }
        else if (type === 'branches' ) {
            changeObjectData[type] = [e]
            getDistrcitStateListForDealer(e,callback=>{
                  const ar = []

            const arr = callback?.data?.length > 0 ? callback?.data?.map((val) => {
                const obj = { name: val, code: val }
                ar.push(obj)
            }) : []
            setDistrictstateData(ar)
            })
        }else if (type === 'panNumber' && changeObjectData[type].length === 10) {
            changeObjectData[type] = e
        } else {
            changeObjectData[type] = e
        }

        setObjectData(changeObjectData)

    }


    const saveHandler = (e) => {
        if (e === 'save') {
            if (!validateForm()) return;
            setloaderState(true)
            console.log("obj",ObjectData)
            const obj = { ...ObjectData }
            if (Detaildata?.rowData?.communityId) {
                obj.communityId = Detaildata?.rowData?.communityId,
                    obj.formStatus = "update"
            }
            saveUpdateCommunityPersonalApi(obj, (callback) => {
                setloaderState(false)
                if (callback.data !== undefined && callback.data !== '' && callback.data !== null) {
                    commId(callback?.data?.communityId)
                    setTimeout(() => {
                        handleTabs("address")
                    }, 200)
                }
            })
        } else if (e === 'close') {
            handlePage("", "list")
        }
    }

    useEffect(() => {
        getStateListForDealerFn()
    }, [])

    const getStateListForDealerFn = () => {
        getStateListForDealer(callback => {
            console.log("call", callback)
            const ar = []

            const arr = callback?.data?.length > 0 ? callback?.data?.map((val) => {
                const obj = { name: val, code: val }
                ar.push(obj)
            }) : []
            setStateData(ar)
        })
    }

    return (
        <>
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}

                <PiePage
                    totalPage={Detaildata?.rowData?.communityId ? 4 : 5}
                    currentPage={1}
                    heading={'Add Basic Info'}
                />


                <div className='row'>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Vendor Name"
                            variant="outlined"
                            value={ObjectData.name}
                            name="name"
                            id="name"
                            type="text"
                            onChange={e => inputChange(e, 'name')}
                            size="small"
                            required={true}
                        />
                        {errors?.name && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.name}</div>}

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Contact Number"
                            variant="outlined"
                            value={ObjectData.mobileNumber}
                            name="mobileNumber"
                            id="mobileNumber"
                            type="number"
                            onChange={e => inputChange(e, 'mobileNumber')}
                            size="small" required={true}

                        />
                        {errors?.mobileNumber && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.mobileNumber}</div>}


                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Email Id"
                            variant="outlined"
                            value={ObjectData.email}
                            name="email"
                            id="email"
                            type="email"
                            onChange={e => inputChange(e, 'email')}
                            size="small" required={true}

                        />
                        {errors?.email && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.email}</div>}
                        {/* {
                            errors?.email &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.email}</div>
                        } */}

                    </div>
                </div>

                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Alternate Email Id"
                            variant="outlined"
                            value={ObjectData.alternativeEmailId}
                            name="alternativeEmailId"
                            id="alternativeEmailId"
                            type="email"
                            onChange={e => inputChange(e, 'alternativeEmailId')}
                            size="small"

                        />
                        {/* {
                            errors?.alternativeEmailId &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternativeEmailId}</div>
                        } */}

                    </div>
                    {/* <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Multiple Email Id"
                            variant="outlined"
                            value={ObjectData.multipleEmail}
                            name="multipleEmail"
                            id="multipleEmail"
                            type="email"
                            onChange={e => inputChange(e, 'multipleEmail')}
                            size="small"

                        />
                       

                    </div> */}
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.communityType}
                            label="Vendor Type"
                            onChange={e => inputChange(e, 'communityType')}
                            name="communityType"
                            data={VendorTypeData}
                            size={'small'}
                            required={true}
                        />
                        {errors?.communityType && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.communityType}</div>}
                        {/* {
                            errors?.communityType &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.communityType}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.active}
                            label="Is Active ?"
                            onChange={e => inputChange(e, 'active')}
                            name="active"
                            data={isActiveData}
                            size={'small'} required={true}

                        />
                        {errors?.active && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.active}</div>}

                    </div>
                </div>



                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>

                        {/* <MultiSelect
                            label={"Vendor States"}
                            onChange={(e) => inputChange(e, "branches")}
                            value={ObjectData?.branches ? ObjectData?.branches : []}
                            inputData={branchesData} required={true} /> */}
                        <SelectField
                            value={ObjectData.branches}
                            label="Vendor States"
                            onChange={e => inputChange(e, 'branches')}
                            name="branches"
                            data={stateData}
                            size={'small'} required={true}

                        />
                        {errors?.branches && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.branches}</div>}

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.vendorBranches}
                            label="Vendor Branches"
                            onChange={e => inputChange(e, 'vendorBranches')}
                            name="vendorBranches"
                            data={DistrictstateData}
                            size={'small'} required={true}

                        />
                        {errors?.vendorBranches && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.vendorBranches}</div>}

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Point Of Contact"
                            variant="outlined"
                            value={ObjectData.pointOfContact}
                            name="pointOfContact"
                            id="pointOfContact"
                            type="text"
                            onChange={e => inputChange(e, 'pointOfContact')}
                            size="small"
                            required={true}
                        />
                        {errors?.pointOfContact && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.pointOfContact}</div>}
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>

                </div>

                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Vender Owner Name"
                            variant="outlined"
                            value={ObjectData.venderOwnerName}
                            name="venderOwnerName"
                            id="venderOwnerName"
                            type="text"
                            onChange={e => inputChange(e, 'venderOwnerName')}
                            size="small"
                            required={true}
                        />
                        {errors?.venderOwnerName && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.venderOwnerName}</div>}
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="PAN Number"
                            variant="outlined"
                            value={ObjectData.panNumber}
                            name="panNumber"
                            id="panNumber"
                            type="text"
                            onChange={e => inputChange(e, 'panNumber')}
                            size="small"
                            // required={true}
                        />
                        {/* {errors?.panNumber && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.panNumber}</div>} */}
                        

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Aadhaar Number"
                            variant="outlined"
                            value={ObjectData.venderAadhaarNumber}
                            name="venderAadhaarNumber"
                            id="venderAadhaarNumber"
                            type="number"
                            onChange={e => inputChange(e, 'venderAadhaarNumber')}
                            size="small"
                            required={true}
                        />
                        {errors?.venderAadhaarNumber && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.venderAadhaarNumber}</div>}
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>

                </div>
                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="GSTIN Number"
                            variant="outlined"
                            value={ObjectData.firmGstNumber}
                            name="firmGstNumber"
                            id="firmGstNumber"
                            type="text"
                            onChange={e => inputChange(e, 'firmGstNumber')}
                            size="small"
                            required={ObjectData.communityType !== "SUB DEALER" ? true : false}
                        />
                        {ObjectData.communityType !== "SUB DEALER" ? errors?.firmGstNumber && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.firmGstNumber}</div> : ""}
                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Tieup Amount"
                            variant="outlined"
                            value={ObjectData.tieUpAmount}
                            name="tieUpAmount"
                            id="tieUpAmount"
                            type="number"
                            onChange={e => inputChange(e, 'tieUpAmount')}
                            size="small"
                            required={true}
                        />
                        {errors?.tieUpAmount && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.tieUpAmount}</div>}
                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        {/* <InputField
                            label="Tieup Fee Paid By"
                            variant="outlined"
                            value={ObjectData.tieUpFeePaidBy}
                            name="tieUpFeePaidBy"
                            id="tieUpFeePaidBy"
                            type="date"
                            onChange={e => inputChange(e, 'tieUpFeePaidBy')}
                            size="small"
                            required={true}
                        /> */}
                         <SelectField
                            value={ObjectData.tieUpFeePaidBy}
                            label="Tieup Fee Paid By"
                            onChange={e => inputChange(e, 'tieUpFeePaidBy')}
                            name="tieUpFeePaidBy"
                            data={tieUpFeePaidByData}
                            size={'small'} required={true}

                        />
                        {errors?.tieUpFeePaidBy && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.tieUpFeePaidBy}</div>}
                    </div>

                </div>

                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Tieup Fee Date"
                            variant="outlined"
                            value={ObjectData.tieUpFeeDate}
                            name="tieUpFeeDate"
                            id="tieUpFeeDate"
                            type="date"
                            onChange={e => inputChange(e, 'tieUpFeeDate')}
                            size="small"
                            required={true}
                        />
                        {errors?.tieUpFeeDate && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.tieUpFeeDate}</div>}
                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Tieup Fee Bank"
                            variant="outlined"
                            value={ObjectData.tieUpFeeBank}
                            name="tieUpFeeBank"
                            id="tieUpFeeBank"
                            type="text"
                            onChange={e => inputChange(e, 'tieUpFeeBank')}
                            size="small"
                            required={true}
                        />
                        {errors?.tieUpFeeBank && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.tieUpFeeBank}</div>}
                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Tieup Fee Reflect Id"
                            variant="outlined"
                            value={ObjectData.tieUpFeeRefId}
                            name="tieUpFeeRefId"
                            id="tieUpFeeRefId"
                            type="text"
                            onChange={e => inputChange(e, 'tieUpFeeRefId')}
                            size="small"
                            required={true}
                        />
                        {errors?.tieUpFeeRefId && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.tieUpFeeRefId}</div>}
                    </div>
                </div>
                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        
                        <SelectField
                            value={ObjectData.agreementFeeType}
                            label="Agreement Fee Type"
                            onChange={e => inputChange(e, 'agreementFeeType')}
                            name="agreementFeeType"
                            data={AgreementFeeData}
                            size={'small'} required={false}

                        />
                        {/* {errors?.tieUpFeeDate && <div className="form-text text-danger" style={{ fontSize: "10px" }}>{errors.tieUpFeeDate}</div>} */}
                    </div>
                 
                </div>

                <div className="row">
                    <div className=' col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            multiline={true}
                            label="Additonal Info"
                            variant="outlined"
                            value={ObjectData.additionalInfo}
                            name="additionalInfo"
                            id="additionalInfo"
                            type="text"
                            onChange={e => inputChange(e, 'additionalInfo')}
                            size="small"

                        />
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>
                </div>

                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger" style={{ fontSize: "10px" }}>{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save and Continue</button>
                    </div>
                </div>
            </div>
        </>
    )
}
